import React, {useState} from 'react';
import {RouteProp, useRoute} from '@react-navigation/native';
import Screen from '../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {useStyles} from '../../../../../shared/hooks/styles';
import {useConfirmEmail} from '../../../../../shared/hooks/useConfirmEmail';
import {isChangeEmailConfirmation} from '../../../../../shared/hooks/useConfirmationDeepLink';
import {EmailConfirmation} from '../../../common/emailConfirmation';

type RouteParams = {op?: string; code?: string};

const EmailConfirmationLayout = ({loading}: {loading: boolean}) => {
  const styles = useStyles(() => ({
    scrollContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'stretch',
    },
  }));

  return (
    <Screen>
      <LoadableContent loading={loading}>
        <CustomScrollView contentContainerStyle={styles.scrollContainer} contentInsetAdjustmentBehavior='automatic'>
          <EmailConfirmation />
        </CustomScrollView>
      </LoadableContent>
    </Screen>
  );
};

const EmailConfirmationByLink = () => {
  const route = useRoute<RouteProp<{params: RouteParams}>>();
  const code = route.params?.code ?? '';
  const [isLoading, setIsLoading] = useState(true);

  useConfirmEmail(true, code, setIsLoading);

  return <EmailConfirmationLayout loading={isLoading} />;
};

export default () => {
  const route = useRoute<RouteProp<{params: RouteParams}>>();
  const op = route.params?.op ?? '';
  const code = route.params?.code ?? '';

  if (isChangeEmailConfirmation(op, code)) {
    return <EmailConfirmationByLink />;
  }

  return <EmailConfirmationLayout loading={false} />;
};
